(function () {
    'use strict';

    angular
        .module('vm.common')
        .factory('DomainSettingsService', DomainSettingsService);

    function DomainSettingsService ($api) {
        let promise;

        return {
            clean,
            get,
        };

        //////////////

        function clean () {
            promise = null;
        }

        function get () {
            if (!promise) {
                promise = $api.get('service/domain-settings')
                    .then((response) => {
                        return response.data;
                    })
                ;
            }

            return promise;
        }
    }
}());